const forumPhoto = (crop, alt, caption) => ({
  src: "/img/events/robotics-forum-2026-original.jpg",
  sourceWidth: 1279,
  sourceHeight: 8199,
  crop,
  alt,
  caption,
});

export const insights = [
  {
    slug: "singapore-robotics-industry-dialogue-2026",
    type: "Events",
    date: "21 August 2026",
    dateTime: "2026-08-21",
    location: "China-Singapore industry exchange",
    title: "Goldly AI joins the Singapore Robotics Industry Matchmaking Forum",
    summary:
      "As one of four invited Singapore AI companies, Goldly AI took part in a China-Singapore dialogue on robotics, artificial intelligence and cross-border business collaboration during the 2026 World Robot Conference.",
    introduction:
      "On the morning of 21 August 2026, Goldly AI (Cloud Gold Pte. Ltd.) joined representatives from government, research, industry and investment at the Singapore Robotics Industry Matchmaking Forum. The discussions connected the capabilities of the two countries' robotics and AI ecosystems with opportunities for technical deployment and commercial cooperation.",
    cover: forumPhoto(
      { x: 48, y: 2130, width: 1180, height: 780 },
      "Goldly AI CTO Frank Sun presenting at the World Robot Conference forum",
      "CTO Frank Sun presents Goldly AI's AI infrastructure, model gateway and enterprise agent capabilities at the forum."
    ),
    sections: [
      {
        heading: "A dialogue across policy, research and industry",
        paragraphs: [
          "The forum brought together participants from Singapore and China to discuss collaboration across the robotics and AI industry chain. Topics spanned policy, technology, industry resources and opportunities to bring new capabilities into commercial use.",
          "The event report lists representatives from the Robotics Society of Singapore (RSS), Singapore Economic Development Board (EDB), A*STAR and Nanyang Technological University (NTU), alongside investors and robotics and AI companies. This mix of participants connected research and technical perspectives with the practical requirements of business expansion."
        ],
        photo: forumPhoto(
          { x: 48, y: 4758, width: 1180, height: 780 },
          "Forum participants gathered for a group photograph in the conference room",
          "Representatives from government, academia, industry and investment at the China-Singapore robotics industry exchange."
        ),
      },
      {
        heading: "Frank Sun introduces Goldly AI's enterprise AI capabilities",
        paragraphs: [
          "Goldly AI CTO Frank Sun delivered a presentation introducing the company's business and three areas of capability: AI-Infra, AI-Gateway and AI-Agent. The presentation placed enterprise agent applications alongside the infrastructure and model access needed to support them.",
          "For Goldly AI, enterprise agents are the application focus. Cloud infrastructure and access to global models support that work, helping connect AI capabilities with the systems and business processes in which they will be used."
        ],
      },
      {
        heading: "Continuing the conversation beyond the stage",
        paragraphs: [
          "During the forum's networking sessions, the Goldly AI team exchanged views with participants on industry resources, technical deployment and commercial cooperation. These smaller conversations created space to discuss the practical questions behind cross-border projects.",
          "Following the forum, founder Dollar Zhang and CTO Frank Sun joined a small networking lunch with guests. Discussions explored how resources across regions, industries and professional networks could support technology innovation and future business development."
        ],
        photo: forumPhoto(
          { x: 48, y: 3826, width: 1180, height: 780 },
          "Goldly AI team members in conversation with guests at the robotics forum",
          "One-to-one discussions during the forum break focused on industry connections, technology deployment and commercial collaboration."
        ),
      },
      {
        heading: "A Singapore base for international AI delivery",
        paragraphs: [
          "Headquartered in Singapore, Goldly AI participated as a link between the local technology ecosystem and enterprises exploring international AI opportunities. The team introduced AWS products and technical capabilities, as well as Singapore market-entry policies and resources relevant to international enterprises and startups.",
          "The event report also highlighted Westcon's role in providing localised services and implementation support. Together, these topics reflected the company's focus on combining AI applications with the technical resources and regional support needed for delivery."
        ],
      },
    ],
    themes: [
      "China-Singapore collaboration",
      "Enterprise AI",
      "Robotics ecosystem",
    ],
    related: ["Enterprise AI Agents", "Global LLM Gateway", "Multi-Cloud AI Infrastructure"],
    sourceNote: "Adapted from Goldly AI's forum report. Event photographs: Goldly AI.",
  },
];
